import { createFileRoute } from "@tanstack/react-router";
import { AIMarketingServicePage } from "./services_.ai-marketing";

export const Route = createFileRoute("/services_/ai-marketing-services")({
  head: () => ({
    meta: [
      {
        title: "AI Marketing Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "AI-Powered Personalization & Marketing Automation.",
      },
    ],
  }),
  component: AIMarketingServicePage,
});
